import { render, staticRenderFns } from "./TemplatesIndex.vue?vue&type=template&id=70176ec0&scoped=true&"
import script from "./TemplatesIndex.vue?vue&type=script&lang=js&"
export * from "./TemplatesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70176ec0",
  null
  
)

export default component.exports